import axios from 'axios'

const invoicesService = {
    getInvoices,
    getInvoicesSummary,
    exporyCahrgingSummaryFile
};

async function getInvoices(filterData) {
    return await axios.post(`/invoice/chargingSummery`, filterData)
}

async function getInvoicesSummary(filterData) {
    return await axios.post(`/invoice/InvoicesSummary`, filterData)
}

async function exporyCahrgingSummaryFile(langCode, filterData) {
    return await axios.post(`/invoice/ExportChargingSummaryFile/${langCode}`, filterData)
}

export default invoicesService;